@if (metaItems.length) {
  <ul class="meta-items" [class.inherit-font]="inheritFont">
    @for (item of metaItems; track item.label) {
      @if (item.count || showEmpty) {
        <li class="meta-item" [ngClass]="itemClass" (click)="itemClicked.emit(item)">
          {{ item.label | translate: { count: item.count, minutes: item.minutes, seconds: item.seconds } }}
        </li>
      }
    }
  </ul>
}
